<div class="row">
  <div class="col-11">
    <mat-form-field appearance="fill" style="width: 20%">
      <mat-label>Container</mat-label>
      <mat-select [(value)]="selectedContainerId" (selectionChange)="containerChange($event.value)">
        <mat-option>None</mat-option>
        @for (constainer of containerList; track constainer) {
          <mat-option [value]="constainer.id">{{constainer.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 24%" class="ml-1">
      <mat-label>Type</mat-label>
      <mat-select [(value)]="selectedContainerTypeId" (selectionChange)="typeChange($event.value)">
        <mat-option>None</mat-option>
        @for (type of typeList; track type) {
          <mat-option [value]="type.id">{{type.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 40%" class="ml-1">
      <mat-label>Status</mat-label>
      <mat-select [(value)]="selectedStatusId" (selectionChange)="statusChange($event.value)">
        <mat-option>None</mat-option>
        @for (status of statusList; track status) {
          <mat-option [value]="status.id">{{status.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div class="pt-2">
  <div class="table-box">
    <div class="row w-100 assets">
      <div class="col-12">
        <table>
          <thead>
            <th>Container</th>
            <th>Type</th>
            <th>On Site</th>
            <th>Status</th>
            <th></th>
          </thead>
          <tbody>
            @for (asset of filteredAssetsOnSite; track asset; let i = $index) {
              <tr>
                <td>{{ asset.id }}</td>
                <td>{{ asset.type }}</td>
                <td>{{ asset.daysOnSite }}</td>
                <td>{{ asset.statusDisplay }}</td>
                <td class="pl-2">
                  <span class="container-icon text-primary me-2 me-md-0 relative-top--2" (click)="openPopup(asset.assetURL === null ? 'https://pinwebsiteimages.blob.core.windows.net/binreportimages/10000_OPN_image_front.jpg' : asset.assetURL)">
                    @if (asset.assetTypeClassification == 0) {
                      <img src="/img/RoRo.png">
                    }
                    @if (asset.assetTypeClassification == 1) {
                      <img src="/img/Skip.png">
                    }
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-image-popup [imageSrc]="selectedImage" [isOpen]="isPopupOpen" (close)="closePopup()"></app-image-popup>
